import React from "react";
import Navbar from "../../components/Home/navbar/Navbar";
import Hero from "../../components/Home/Hero/HeroSection";
import FeaturedProducts from "../../components/Home/featured/FeaturedProducts";
import TrendingProducts from "../../components/Home/Products/Products";
import DemandedProducts from "../../components/Home/DemandedProducts/DemandedProducts";
import Enquiry from "../../components/Home/Enquiry/Enquiry";
import Services from "../../components/Home/Services/Services";
import FindByCountries from "../../components/Home/FindByCountries/Countries";
import Events from "../../components/Home/Events/Events";
import FeaturedCategories from "../../components/Home/FeaturedCategories/Categories";
import PopularProducts from "../../components/Home/PopularProducts/PopularProducts";
import Footer from "../../components/Home/Footer/Footer";

const Home = () => {
  return (
    <div>
      <div className="md:sticky md:top-0 md:z-50">
        <Navbar />
      </div>
      <Hero />
      <FeaturedProducts />
      <TrendingProducts />
      <DemandedProducts />
      <Enquiry />
      <Services />
      {/* <FindByCountries /> */}
      <Events />
      <FeaturedCategories />
      <PopularProducts />
      <Footer />
    </div>
  );
};

export default Home;
